import { render, staticRenderFns } from "./mallBanner.vue?vue&type=template&id=63d97582&scoped=true&"
import script from "./mallBanner.vue?vue&type=script&lang=js&"
export * from "./mallBanner.vue?vue&type=script&lang=js&"
import style0 from "./mallBanner.vue?vue&type=style&index=0&id=63d97582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d97582",
  null
  
)

export default component.exports